exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-55858cda] .el-textarea__inner{border:1px solid!important;border-color:var(--cockpitInputBorderColor)!important;background-color:var(--cockpitInputBgColor)!important;color:var(--cockpitInputFontColor)!important}[data-v-55858cda] .el-textarea__inner:hover{border-color:var(--cockpitInputHoverBorderColor)!important}", ""]);

// exports
